import axios from '@/plugins/axios'

const toggleFavorite = async (id, modelType, action) => {
  try {
    const params = {
      model_type: modelType
    }
    if (action === 'destroy') {
      params._method = 'DELETE'
    }
    if (modelType === 'post') {
      params.post_id = id
    } else if (modelType === 'book') {
      params.book_id = id
    } else if (modelType === 'comment') {
      params.comment_id = id
    }

    const response = await axios.post('favorites', params)
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

const getFavorites = async ({ id, modelType, page = 1 }) => {
  try {
    const params = {
      model_type: modelType,
      page: page
    }
    if (modelType === 'post') {
      params.post_id = id
    } else if (modelType === 'book') {
      params.book_id = id
    } else if (modelType === 'comment') {
      params.comment_id = id
    }

    const response = await axios.get('favorites', {
      params: params
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export default {
  getFavorites,
  toggleFavorite
}
